import { render } from "./SendBulkSmsView.vue?vue&type=template&id=56f5b4c0&scoped=true"
import script from "./SendBulkSmsView.vue?vue&type=script&lang=js"
export * from "./SendBulkSmsView.vue?vue&type=script&lang=js"

import "@/assets/css/report.css?vue&type=style&index=0&id=56f5b4c0&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f5b4c0"]])

export default __exports__